import bases from './util/bases.js';
export function fromString(string) {
  let encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'utf8';
  const base = bases[encoding];
  if (!base) {
    throw new Error("Unsupported encoding \"".concat(encoding, "\""));
  }
  if ((encoding === 'utf8' || encoding === 'utf-8') && globalThis.Buffer != null && globalThis.Buffer.from != null) {
    return globalThis.Buffer.from(string, 'utf8');
  }
  return base.decoder.decode("".concat(base.prefix).concat(string));
}